/* eslint-disable no-console */
import React, { Component } from 'react'
import { Button, Col, Modal, Row, Space, Switch, Tabs, Typography } from 'antd'
import delta from '../../../../../assets/images/delta.png'
import deltaLogo from '../../../../../assets/images/DL-red.png'
import AcDetails from './acdetails'
import ContainerDetails from './containerdetails'
import AcType359 from './actype359'
import AcType764 from './actype764'
import AcType763 from './actype763'
import AcType333 from './actype333'
import AcType339 from './actype339'
import AcType332 from './actype332'
import http from '../../../../../utils/http'
import DryIce from './dryice'
import moment from 'moment'
import Cookies from 'universal-cookie'
import html2canvas from 'html2canvas'

const { Text } = Typography
const cookies = new Cookies()
const { TabPane } = Tabs
class WeightAndBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      flight: {
        flight_no: null,
        flight_date: null,
      },
      recordid: null,
      record: null,
      wgt_bal_status: null,
      aft_index: null,
      cargo_margin: null,
      ship: null,
      type: 'Domestic',
      pax: {
        c: 0,
        f: 0,
        w: 0,
        y: 0
      },
      fuel: 0,
      position: {
        pallet: {},
        cargo: {},
        bulk: 0
      },
      season: 'Summer',
      acdetails: {},
      ac_title: '',
      viewMode: 'sm',
      activeTab: 'wnb',
      visibleTabs: ['wnb', 'initial', 'final'],
    }
    this.acTypeText = ''
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    // Inject .wnb-modal-expanded CSS if not already present
    if (typeof document !== 'undefined' && !document.getElementById('wnb-modal-expanded-style')) {
      const style = document.createElement('style')
      style.id = 'wnb-modal-expanded-style'
      style.innerHTML = `
      .wnb-modal-expanded {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }
      /* Also expand the modal body and wrapper when screenshotting */
      .wnb-modal .ant-modal-content,
      .wnb-modal .ant-modal-body {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }
    `
      document.head.appendChild(style)
    }
    this.fetchData()
  }

  fetchData = () => {
    this.setState({
      recordid: this.props.editRecordId,
      record: this.props.editRecord,
    })
    let ulds = {}
    switch (this.props.editRecord?.fleet) {
    case '359':
      ulds = {
        p11: 'PMC',
        p21: 'PAG',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p31: 'PMC',
        p32: 'PMC',
        p33: 'PMC',
        p34: 'PMC',
        p41: 'PMC',
      }
      break
    case '764':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
      }
      break
    case '763':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
      }
      break
    case '333':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p32: 'PMC',
        p33: 'PMC',
        p34: 'PAG',
        p41: 'PMC',
      }
      break
    case '339':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p33: 'PMC',
        p34: 'PAG',
        p41: 'PMC',
      }
      break
    case '332':
      ulds = {
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p31: 'PMC',
        p32: 'PMC',
        p33: 'PMC',
        p41: 'PMC',
      }
      break
    default:
      ulds = {}
    }


    if (this.props.editRecord?.wgt_bal_plan) {
      let positionData = { ...this.props.editRecord?.wgt_bal_plan?.position } || {
        pallet: {},
        cargo: {},
        bulk: 0
      }
      if (!positionData?.pallet_uld || (positionData?.pallet_uld && Object.keys(positionData?.pallet_uld).length == 0)) {
        positionData['pallet_uld'] = ulds
      }
      console.log('WeightAndBalance fetchData', positionData)

      this.setState({
        flight: {
          flight_no: this.props.editRecord?.flight_no,
          flight_date: moment(this.props.editRecord?.flight_date).format('DDMMMYY')?.toUpperCase(),
        },
        wgt_bal_status: this.props.editRecord?.wgt_bal_status,
        aft_index: this.props.editRecord?.aft_index,
        ship: this.props.editRecord?.wgt_bal_plan?.ship,
        type: this.props.editRecord?.wgt_bal_plan?.type,
        pax: this.props.editRecord?.wgt_bal_plan?.pax,
        fuel: this.props.editRecord?.wgt_bal_plan?.fuel,
        season: this.props.editRecord?.wgt_bal_plan?.season,
        position: positionData,
        cargo_margin: this.props.editRecord?.wgt_bal_plan?.cargo_margin
      })
    } else {
      this.setState({
        flight: {
          flight_no: this.props.editRecord?.flight_no,
          flight_date: moment(this.props.editRecord?.flight_date).format('DDMMMYY')?.toUpperCase(),
        },
        ship: null,
        type: 'Domestic',
        pax: {
          c: 0,
          f: 0,
          w: 0,
          y: 0
        },
        fuel: 0,
        position: {
          pallet: {},
          cargo: {},
          bulk: 0,
          pallet_uld: ulds
        },
        season: 'Summer',
        cargo_margin: 0
      })
    }
  }

  componentDidUpdate(prevProps) {
    console.log('WeightAndBalance componentDidUpdate', this.props.editRecord, prevProps.editRecord)
    if (this.props.editRecordId !== prevProps.editRecordId) {
      this.setState({ recordid: this.props.editRecordId })
    }
    if (this.props.editRecord !== prevProps.editRecord) {
      this.fetchData()
    }
  }

  onSubmit = () => {
    http.post(`/wgt_bal_plan/${this.state.recordid}`, {
      ship: this.state.ship,
      type: this.state.type,
      pax: this.state.pax,
      fuel: this.state.fuel,
      position: this.state.position,
      season: this.state.season,
    })
    // .then(({ data }) => {
    //   if (data.data) {
    //     this.setState({
    //       wgt_bal_plan: data.data.wgt_bal_plan,
    //       wgt_bal_status: data.data.wgt_bal_status,
    //       aft_index: data.data.aft_index,
    //       position: data.data?.wgt_bal_plan?.position
    //     })
    //   }
    // }).catch(() => {
    // })
  }

  onChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({ [name]: value }, () => {
      if (name !== 'ship')
        this.onSubmit()
    })

  }

  onChangePax = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      pax: {
        ...this.state.pax,
        [name]: value
      }
    }, () => {
      this.onSubmit()
    })
  }

  onChangePosition = (e, i, t) => {
    if (t === 'bulk') {
      this.setState({
        position: {
          ...this.state.position,
          [t]: e
        },
      })
    }
    else {
      this.setState({
        position: {
          ...this.state.position,
          [t]: {
            ...this.state.position[t],
            [i]: e
          }
        },
      })
    }
  }

  aftStatus = (aftIndex) => {
    let aftStatus = ''
    if (aftIndex) {
      if (aftIndex > 81 && aftIndex < 10000) {
        aftStatus = 'Tail Heavy'
      }
      else if (aftIndex < 19) {
        aftStatus = 'Nose Heavy'
      }
      return aftStatus
    }
  }

  aftIndexStyle = (aftIndex) => {
    if (aftIndex) {
      if (aftIndex <= 0 || aftIndex >= 100) {
        return {
          backgroundColor: 'var(--danger)',
          color: 'white',
          fontWeight: 'bold'
        }
      } else if ((aftIndex >= 1 && aftIndex <= 19) || (aftIndex >= 81 && aftIndex <= 99)) {
        return {
          backgroundColor: '#d9d301',
          color: 'black'
        }
      } else {
        return {
          backgroundColor: 'var(--success)',
          color: 'white',
          fontWeight: 'bold'
        }
      }
    } else {
      return { color: 'black' }
    }
  }

  clearBin = () => {
    this.setState({
      position: {
        pallet: {},
        cargo: {},
        bulk: 0
      }
    }, () => {
      this.onSubmit()
    })
  }

  acTypeChange = () => {
    let optimal = true
    switch (this.props.editRecord?.fleet) {
    case '359':
      return (
        (!this.state.position?.pallet?.p34 && this.state.position?.pallet?.p33) || (this.state.position?.pallet?.p34 && !this.state.position?.pallet?.p33) || (!this.state.position?.pallet?.p32 && this.state.position?.pallet?.p31) || (this.state.position?.pallet?.p32 && !this.state.position?.pallet?.p31) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p41) ? optimal = false : optimal = true,
        <AcType359
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '764':
      optimal = this.props.editRecord?.build_uld?.find((u) => u.type === 'LD3') ? false : true
      return (
        <AcType764
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '763':
      optimal = this.props.editRecord?.build_uld?.find((u) => u.type === 'LD3') ? false : true
      return (
        <AcType763
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '333':
      ((this.state.position?.pallet_uld?.p33 == 'PMC' && this.state.position?.pallet?.p33 > 0) && ((this.state.position?.pallet_uld?.p32 == 'PMC' && this.state.position?.pallet?.p32 > 0) && (this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0))) ? optimal = 'ERROR - If a 96” pallet is loaded in position 33P, position 32P and 34P must remain empty or with 88” pallets only.' : (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p34) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p34) || (!this.state.position?.pallet?.p33 && this.state.position?.pallet?.p32) || (this.state.position?.pallet?.p33 && !this.state.position?.pallet?.p32) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) ? optimal = 'Suboptimal Configuration: Unpaired Pallet' : optimal = true
      return (
        <AcType333
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '339':
      ((this.state.position?.pallet_uld?.p33 == 'PMC' && this.state.position?.pallet?.p33 > 0) && ((this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0))) ? optimal = 'ERROR - If a 96” pallet is loaded in position 33P, position 34P must be PAG.' :
        (this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0) && (this.state.position?.cargo?.l34 > 0 || this.state.position?.cargo?.r34 > 0) ? optimal = 'ERROR - 34P must be PAG if LD3/PLA in 34L/R or LD2/PLB in 21L/R' :
          (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p34) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p34) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p33) ? optimal = false : optimal = true
      return (
        <AcType339
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '332':
      (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p33) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p33) || (!this.state.position?.pallet?.p32 && this.state.position?.pallet?.p31) || (this.state.position?.pallet?.p32 && !this.state.position?.pallet?.p31) || (!this.state.position?.pallet?.p24 && this.state.position?.pallet?.p23) || (this.state.position?.pallet?.p24 && !this.state.position?.pallet?.p23) || (!this.state.position?.pallet?.p22 && this.state.position?.pallet?.p21) || (this.state.position?.pallet?.p22 && !this.state.position?.pallet?.p21) ? optimal = false : optimal = true
      return (
        <AcType332
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.getULD()}
          bag_wgt={this.props.editRecord?.wgt_bal_plan?.bag_pos_wgt || 0}
          onSubmit={this.onSubmit}
          editRecord={this.props.editRecord}
          copy={this.props.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    default:
      return null
    }
  }

  acTypeName = () => {
    let acTypeText = ''
    switch (this.props.editRecord?.fleet) {
    case '359':
      acTypeText = 'AIRBUS A350-900B'
      break
    case '764':
      acTypeText = 'BOEING 767-400ER'
      break
    case '763':
      acTypeText = 'BOEING 767-300ER'
      break
    case '333':
      acTypeText = 'AIRBUS A330-300'
      break
    case '339':
      acTypeText = 'AIRBUS A330-900NEO'
      break
    case '332':
      acTypeText = 'AIRBUS A330-200'
      break
    default:
      return null
    }
    return acTypeText
  }

  getULD = () => {
    let ulds = []
    if (this.props.editRecord?.build_uld && this.props.editRecord?.build_uld?.length > 0) {
      this.props.editRecord?.build_uld?.map((u) => {
        let wgt = u?.data?.tare_wgt || 0
        let remark = ''
        let pri = []
        if (this.props.editRecord && this.props.editRecord?.build_plan && this.props.editRecord?.build_plan?.length > 0) {
          this.props.editRecord?.build_plan?.map((item) => {
            if (item?.ulds && item?.ulds?.length > 0) {
              item?.ulds?.map((uld) => {
                // eslint-disable-next-line
                console.log(uld, item)
                if (uld.id && uld.id == u.id) {
                  wgt = wgt + uld.wgt,
                  uld.remark ? pri.push(uld.remark) : {}
                }
              }
              )
            }
          })
        }
        // sort priority  
        if (pri && pri.length > 0) {
          pri.sort((a, b) => a - b)
          remark = pri[0]
        }
        ulds.push({
          id: u.id,
          uld_type: u.type + (u.uld_no ? u.uld_no : ''),
          wgt: wgt,
          remark: remark
        })
      })
    }
    return ulds
  }

  callbackTabClicked = (key) => {
    this.setState({ activeTab: key })
    if (key === 'initial') {
      if (this.props.openInitWB) {
        this.props.openInitWB(true)
      }
    }
    else if (key === 'final') {
      if (this.props.openFinalWB) {
        this.props.openFinalWB(true)
      }
    }
    else this.props.openWnb(true)

  }

  onTabEdit = (targetKey, action) => {
    if (action === 'remove') {
      this.removeTab(targetKey)
    }
  }

  removeTab = (targetKey) => {
    const { visibleTabs, activeTab } = this.state
    const newVisibleTabs = visibleTabs.filter(key => key !== targetKey)

    // Call unlock function based on which tab is being removed
    if (targetKey === 'initial') {
      this.props.unlockWB({ init: true })
    } else if (targetKey === 'final') {
      this.props.unlockWB({ final: true })
    }

    // If removing the active tab, switch to the first available tab
    let newActiveTab = activeTab
    if (activeTab === targetKey && newVisibleTabs.length > 0) {
      newActiveTab = newVisibleTabs[0]
    }

    this.setState({
      visibleTabs: newVisibleTabs,
      activeTab: newActiveTab
    })
  }

  handleLockAndScreenshot = () => {
    if (this.props.lockWB) {
      this.props.lockWB()
    }
    setTimeout(() => {
      let fieldName = 'wandb_conf'
      let type = 'proposed_'
      if (!this.props.editRecord?.init_wgt_bal_plan) {
        fieldName = 'wandb_conf'
        type = 'proposed_'
      } else {
        fieldName = 'wandb_conf2'
        type = 'final_w'
      }
      const node = this.modalContentRef.current
      if (node) {
        node.classList.add('wnb-modal-expanded')
        node.scrollTop = 0
        setTimeout(() => {
          html2canvas(node).then(canvas => {
            node.classList.remove('wnb-modal-expanded')
            canvas.toBlob(blob => {
              if (this.props.onWandbImageReady) {
                // Pass the blob and filename to parent
                const filename = `WeightAndBalance_${type}${this.state.flight.flight_no || 'flight'}.png`
                this.props.onWandbImageReady(blob, filename, fieldName)
              }
            }, 'image/png')
          })
        }, 100)
      }
    }, 500)
  }

  render() {
    const acType = this.acTypeChange()
    const acName = this.acTypeName()
    const modalTitle =
      <Row gutter={[{
        xs: 0,
        sm: 0,
        md: 24,
        lg: 48
      }, {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 48
      },]} className='modal-title fv-middle'>
        <Col
          // xs={{
          //   span: 12,
          //   order: 1,
          // }}
          // sm={{
          //   span: 12,
          //   order: 1,
          // }}
          // md={{
          //   span: 12,
          //   order: 1,
          // }}
          // lg={{
          //   span: 5,
          //   order: 1,
          // }}
          // xl={{
          //   span: 5,
          //   order: 1,
          // }}
          // xxl={{
          //   span: 8,
          //   order: 1,
          // }}
          flex='none'
          className=''>
          <div className='dl-logo'><img src={delta} /> </div>
          <Text className='wnb-flight'> {this.state.flight?.flight_no} | {this.state.flight?.flight_date}</Text>
        </Col>
        <Col flex={1} className='content-ht-half'>
          {/* <div className='d-flex ac-title-wrapper'> */}
          <div className='center-ac text-center'>
            <span className='center-title'>Weight & Balance Planner</span>
            <span className='ac-name'>{acName}</span>
          </div>
        </Col>
        <Col>
          <DryIce fleetType={this.props.editRecord?.fleet} ship_no={this.state.ship} />
        </Col>
        <Col flex='none' className='content-ht-half'>
          <div className='my-2 logo'><img src={deltaLogo} /></div>
        </Col>
      </Row>

    const renderTabContent = () => (
      <>
        <AcDetails
          fleet={this.props.editRecord?.fleet}
          onChange={this.onChange}
          onChangePax={this.onChangePax}
          ship={this.state.ship}
          type={this.state.type}
          pax={this.state.pax}
          fuel={this.state.fuel}
          season={this.state.season}
          aft_index={this.state.aft_index}
          wgt_bal_status={this.state.wgt_bal_status}
          aftIndexStyle={this.aftIndexStyle}
          aftStatus={this.aftStatus}
          cargo_margin={this.state.cargo_margin}
          ccPlanModalVisible={this.props.ccPlanModalVisible}
          onSubmit={this.onSubmit}
        />
        {acType}
      </>
    )
    return (
      <Modal
        title={null}
        open={this.props.openPlanner}
        closable={true}
        onCancel={() => this.props.openWB(false)}
        zIndex={1001}
        footer={this.props.disableInputs ? false : <>
          <Space size='middle' align='center' className=' wnb-btn-container'>
            <Space size='middle'>
              {!this.props.copy && cookies.get('station') === 'LHR' && <Button className='wnb-footer-button' onClick={this.props.trimPlan}>Trim Plan</Button>}
              {!this.props.copy && this.props.editRecord?.trim_plan && <Button className='wnb-footer-button' onClick={this.props.openTruckPlanner}>{this.props.editRecord?.trim_plan?.plan}</Button>}
            </Space>
            <Space size='middle' align='flex-end' className=' wnb-btn-container'>
              {!this.props.copy && <Button className='wnb-footer-button' onClick={this.handleLockAndScreenshot}>Lock W & B</Button>}
              <Button className='wnb-footer-button mr-2' onClick={() => this.props.openWB(false)}> Close  </Button>
            </Space>
          </Space>
        </>
        }
        width='100%'
        centered
        className='custom-modal pb-0 wnb-modal'
      >
        <div ref={this.modalContentRef}>
          {modalTitle}
          <div className='wnb-switch-container'>
            <Space size='small' className='wnb-switch'>
              <span className='switch-label'>Aircraft View : &nbsp;</span>
              <span className='switch-label'>Small</span>
              <Switch
                checkedChildren=''
                unCheckedChildren=''
                size='default'
                checked={this.state.viewMode === 'lg'}
                onChange={(e) => this.setState({ viewMode: e ? 'lg' : 'sm' })}
              />
              <span className='switch-label'>Large</span>
            </Space>
          </div>
          <Tabs
            activeKey={this.state.activeTab}
            onChange={this.callbackTabClicked}
            onEdit={this.onTabEdit}
            type='editable-card'
            hideAdd
            className='wnb-tab position-relative'
          >
            <TabPane tab='W&B' key='wnb' closable={false}>{renderTabContent()}</TabPane>
            {this.props.editRecord?.init_wgt_bal_plan &&
              <TabPane tab='Proposed' key='initial' closable={true}>{renderTabContent()}</TabPane>

            }
            {this.props.editRecord?.final_wgt_bal_plan &&
              <TabPane tab='Final' key='final' closable={true}>{renderTabContent()}</TabPane>
            }
          </Tabs>
          <ContainerDetails data={this.props.editRecord.wgt_bal_plan || {
            position: {
              pallet_uld: {},
              pallet: {} 
            } 
          }} ulds={this.getULD()} />
        </div>

      </Modal>
    )
  }
}
export default WeightAndBalance
